import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Navigation from './components/Navigation.js';
import Footer from './components/Footer.js';
import ScrollToTop from './components/ScrollToTop.js';

import Contact from './pages/Contact.js';
import Home from './pages/Home.js';
import Products from './pages/Products.js';
import ProductDetails from './pages/ProductDetails.js';
import FinancialTools from './pages/FinancialTools.js';
import ThreeWealthyJars from './pages/ThreeWealthyJars.js';

import Academy from './pages/academy/Academy.js';
import Kids from './pages/academy/Kids.js';
import TeensAndAdults from './pages/academy/TeensAndAdults.js';
import PrivateGroup from './pages/academy/PrivateGroup.js';
import Corporate from './pages/academy/Corporate.js';
import Government from './pages/academy/Government.js';
import CourseDetail from './pages/academy/CourseDetail.js';

import About from './pages/organization/About.js';
import Founder from './pages/organization/Founder.js';
import Trainers from './pages/organization/Trainers.js';
import GameMasters from './pages/organization/GameMasters.js';
import Vision from './pages/organization/Vision.js';
import SocialProjects from './pages/organization/SocialProjects.js';
import Press from './pages/organization/Press.js';
import PartnersAndClients from './pages/organization/PartnersAndClients.js';


function App() {
  useEffect(() => {
  const handleOrientationChange = () => {
    const meta = document.getElementById('viewport-meta');
    if (!meta) return;

    // Force Safari to reset zoom
    meta.setAttribute(
      'content',
      'width=device-width, initial-scale=1, viewport-fit=cover'
    );

    // iOS Safari needs a delay
    setTimeout(() => {
      meta.setAttribute(
        'content',
        'width=device-width, initial-scale=1, viewport-fit=cover'
      );
    }, 300);
  };

  window.addEventListener('orientationchange', handleOrientationChange);
  return () =>
    window.removeEventListener('orientationchange', handleOrientationChange);
}, []);
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navigation />
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/academy" element={<Academy />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/tools" element={<FinancialTools />} />
          <Route path="/tools/three-wealthy-jars" element={<ThreeWealthyJars />} />
          {/* Product list page */}
          <Route path="/products" element={<Products />} />
          {/* Dynamic product detail page */}
          <Route path="/products/:productName" element={<ProductDetails />} />

          {/*Academy pages*/}
          <Route path="/academy/kids" element={<Kids />} />
          <Route path="/academy/teens-adults" element={<TeensAndAdults />} />
          <Route path="/academy/private-group" element={<PrivateGroup />} />
          <Route path="/academy/corporate" element={<Corporate />} />
          <Route path="/academy/government" element={<Government />} />
          <Route path="/academy/:category/:slug" element={<CourseDetail />} />

          {/*Organization pages*/}
          <Route path="/organization" element={<About />} />
          <Route path="/organization/about" element={<About />} />
          <Route path="/organization/team" element={<Founder />} />
          <Route path="/organization/team/founder" element={<Founder />} />
          <Route path="/organization/team/trainers" element={<Trainers />} />
          <Route path="/organization/team/game-master" element={<GameMasters />} />
          <Route path="/organization/vision" element={<Vision />} />
          <Route path="/organization/social-projects" element={<SocialProjects />} />
          <Route path="/organization/press" element={<Press />} />
          <Route path="/organization/partners-clients" element={<PartnersAndClients />} />



          {/* Catch-all: redirect unknown paths to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      <Footer/>
    </BrowserRouter>
  );
}

export default App;
